import * as React from 'react';

const ColumnSelectorChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} {...props}>
        <path d="M21 4v16H4V4h17zM9 6H6v12h3V6zm5 0h-3v12h3V6zm5 0h-3v12h3V6z" />
    </svg>
);

ColumnSelectorChunkySvg.displayName = 'ColumnSelectorChunkySvg';
export default ColumnSelectorChunkySvg;
